<template>
  <div>

    <!-- 面包屑导航 -->
    <el-breadcrumb separator=">">
      <el-breadcrumb-item>Active Report</el-breadcrumb-item>
      <el-breadcrumb-item>活跃行为分布</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>


    <div class="container">
      <div style=" margin-right: 80px; "> </div>
      <div style=" margin-right: 80px; "> 过滤掉纯播放的MIniGame <el-switch v-model="switchFilter"></el-switch> </div>
      <div style="margin-bottom: 2px; margin-right: 20px; " size="medium">

        <el-radio-group v-model="radioCycle" style="margin-right: 20px; " size="medium">
          <el-radio-button label="daily">daily</el-radio-button>
          <el-radio-button label="weekly">weekly</el-radio-button>
          <el-radio-button label="monthly">monthly</el-radio-button>
        </el-radio-group>

     
        <el-date-picker
      v-if="radioCycle === 'daily'"
      v-model="year"
      style="margin-right: 20px;"
      type="year"
placeholder="选择年份"
      range-separator="-"
      value-format="yyyy"
      :default-time="['00:00:00', '23:59:59']"
      :picker-options="{
        disabledDate(time) {
          return time.getFullYear() < 2021 ;
        }
      }"  ></el-date-picker>
       

        <el-radio-group v-model="radioType" style="margin-right: 20px; " size="medium">
          <el-radio-button label="pad">pad</el-radio-button>
          <el-radio-button label="app">app</el-radio-button>
          <el-radio-button label="all">all</el-radio-button>
          <el-radio-button label="xbike">xbike</el-radio-button>
          <el-radio-button label="litbike">litbike</el-radio-button>
          <el-radio-button label="boombike">boombike</el-radio-button>
          <el-radio-button label="boombasic">boombasic</el-radio-button>
          <el-radio-button label="ebike">ebike</el-radio-button>
        </el-radio-group>
      </div>
    </div>


    <h3 style="text-align: left;">      活跃分布图表</h3>
    <div id="echart"> </div>


<h3 style="text-align: left;">活跃分布数据       <el-button type="primary" @click="exportCsv"   style="  margin-left: 75%; " >下载 CSV</el-button></h3>

    <el-table :data="tableData" stripe style="width: 100%" height="950"
      :default-sort="{ prop: 'title', order: 'descending' }">

      <el-table-column prop="title" label="日期" width="180" sortable>
      </el-table-column>



      <el-table-column prop="count_total" label="总次数">
      </el-table-column>

      <el-table-column prop="just_ride_count" label="just_ride次数">
      </el-table-column>
      <el-table-column prop="bicycle_count" label="bicycle次数">
      </el-table-column>
      <el-table-column prop="dumbbells_count" label="dumbbells次数">
      </el-table-column>
      <el-table-column prop="stretch_count" label="stretch次数">
      </el-table-column>
      <el-table-column prop="special_training_count" label="special_training次数">
      </el-table-column>
      <el-table-column prop="mini_game_count" label="mini_game次数">
      </el-table-column>
      <el-table-column prop="scenic_ride_count" label="scenic_ride次数">
      </el-table-column>
      <el-table-column prop="tour_3d_map_count" label="tour_3d_map次数">
      </el-table-column>

      <el-table-column prop="duration_total" label="总时间"> </el-table-column>

      <el-table-column prop="just_ride_duration" label="just_ride时间">
      </el-table-column>
      <el-table-column prop="bicycle_duration" label="bicycle时间">
      </el-table-column>
      <el-table-column prop="dumbbells_duration" label="dumbbells时间">
      </el-table-column>
      <el-table-column prop="stretch_duration" label="stretch时间">
      </el-table-column>
      <el-table-column prop="special_training_duration" label="special_training时间">
      </el-table-column>
      <el-table-column prop="mini_game_duration" label="mini_game时间">
      </el-table-column>
      <el-table-column prop="scenic_ride_duration" label="scenic_ride时间">
      </el-table-column>
      <el-table-column prop="tour_3d_map_duration" label="tour_3d_map时间">
      </el-table-column>


    </el-table>


  </div>
</template>

<script>
import { exportToCsv } from '@/utils/exportToCsv';


export default {
  data() {
    return {
      tableData: [],
      radioCycle: 'weekly',
      radioType: 'pad',
      year:'2024',
      switchFilter: true,
    }
  },
  // 在 Vue 实例或组件中定义过滤器
  //不知道为什么 现在还没法用, 持续看看吧
  filters: {
    formatDecimal(value) {
      return parseFloat(value).toFixed(2);
    }
  },
  watch: {

    //watch  观察变化

    radioCycle(newVal, oldVal) {

      this.getData(this.radioType, this.radioCycle,this.switchFilter,this.year)
    },


    radioType(newVal, oldVal) {
      this.getData(this.radioType, this.radioCycle,this.switchFilter,this.year)
    },

    switchFilter(newVal, oldVal) {
      this.getData(this.radioType, this.radioCycle,this.switchFilter,this.year)
    },
    year(newVal, oldVal) {
      this.getData(this.radioType, this.radioCycle,this.switchFilter,this.year)
    },

  },
  created: function () {
    //注意回调函数的作用域!!!
  },

  methods: {
    async getData(bikeType, cycle, filter,year) {

      this.tableData = []

      let res = await this.$http.get("/da/active_distribution/" + cycle + "/" + bikeType + "/" + filter+ "/" + year)  //activityWeekly
      this.tableData = res.data
      // console.log(res.data)
      //渲染图表
      this.getLoadEcharts();
    },

    getLoadEcharts() {


      var chart = this.$echarts.init(
        document.getElementById("echart")
      );

      //进行数据预处理

 // 创建 dataChart 数组
const dataChart = this.tableData.map(item => ({
  title: item.title,
  just_ride_duration_ratio: item.just_ride_duration / item.duration_total,
  bicycle_duration_ratio: item.bicycle_duration / item.duration_total-0.000001,//避免坐标轴超过1
  dumbbells_duration_ratio: item.dumbbells_duration / item.duration_total,
  stretch_duration_ratio: item. stretch_duration / item.duration_total,
  special_training_duration_ratio: item. special_training_duration / item.duration_total,
  mini_game_duration_ratio: item.mini_game_duration / item.duration_total,
  scenic_ride_duration_ratio: item.scenic_ride_duration / item.duration_total,
  tour_3d_map_duration_ratio: item.tour_3d_map_duration / item.duration_total,

}));

// if (dataChart.length > 50) {
//   dataChart = dataChart.slice(dataChart.length - 50);
//       }
      console.log("data  option\n", dataChart);


 // 创建堆叠柱状图的配置项
 const options = {
        title: {
          text: '活跃时长占比' // 添加标题
        },
        // 配置项tooltip
        tooltip: {
  trigger: 'axis',
  axisPointer: {
    type: 'cross',
    label: {
      backgroundColor: '#6a7985'
    }
  },
  formatter: function (params) {
    let tooltipText = `${params[0].axisValue}<br/>`; // 显示日期
    params.forEach(param => {
      tooltipText += `${param.seriesName}: ${(param.value*100).toFixed(2)}%<br/>`; // 将浮点数值转换为带百分号的格式
    });
    return tooltipText;
  }
},



        xAxis: {
          // 设置横坐标轴的数据
          data: dataChart.map(item => item.title)
        },
        yAxis: {
          // 配置纵坐标轴的设置...
          // 配置纵坐标轴的设置...

        },
        legend: {
          // 添加图例
          data: ['just_ride', 'bicycle', 'dumbbells','stretch','special_training','mini_game','scenic_ride','tour_3d_map']
        },
        series: [
          {
            name: 'just_ride',
            type: 'bar',
            stack: '时长',
            data: dataChart.map(item => item.just_ride_duration_ratio)
          },
          {
            name: 'bicycle',
            type: 'bar',
            stack: '时长',
            data: dataChart.map(item => item.bicycle_duration_ratio)
          },
          {
            name: 'dumbbells',
            type: 'bar',
            stack: '时长',
            data: dataChart.map(item => item.dumbbells_duration_ratio)
          },
          {
            name: 'stretch',
            type: 'bar',
            stack: '时长',
            data: dataChart.map(item => item.stretch_duration_ratio)
          },
          {
            name: 'special_training',
            type: 'bar',
            stack: '时长',
            data: dataChart.map(item => item.special_training_duration_ratio)
          },
          {
            name: 'mini_game',//'mini_game','scenic_ride','tour_3d_map'
            type: 'bar',
            stack: '时长',
            data: dataChart.map(item => item.mini_game_duration_ratio)
          },
          {
            name: 'scenic_ride',
            type: 'bar',
            stack: '时长',
            data: dataChart.map(item => item.scenic_ride_duration_ratio)
          },
          {
            name: 'tour_3d_map',
            type: 'bar',
            stack: '时长',
            data: dataChart.map(item => item.tour_3d_map_duration_ratio)
          },
        ]
      };
      // 使用配置项显示图表
      chart.setOption(options);

    },


    formatDecimal(value) {
      return parseFloat(value).toFixed(2);
    },
    exportCsv(){
      let  fileName  =   "Active Distribution_"+ this.radioType+  "_"+ this.radioCycle+  "_"+ this.switchFilter   +  "_"+  this.year
      exportToCsv(this.tableData,fileName)
    },

  },




  mounted: function () {
    //注意回调函数的作用域!!!

    this.getData(this.radioType, this.radioCycle,this.switchFilter,this.year)
  }



}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: flex;
  justify-content: flex-end;
}

#echart {
  width: 90%;
  height: 450px;
  margin: auto;
  border: 0px solid #060632;
}
</style>